module.exports = __webpack_public_path__ + "img/bg-404.179a6a5d.svg";